import { render, staticRenderFns } from "./mensajevuetify.vue?vue&type=template&id=f8d8b13e"
import script from "./mensajevuetify.vue?vue&type=script&lang=js"
export * from "./mensajevuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports